<template lang="pug">
.panel-page-white
  .panel-white.body-2.mx-auto
    PageHeader My Searches
    .search.ml-auto
      SearchBar.body-1(v-model="searchText")
    Datatable.mt-3(
      :columns="columns"
      :entries="filteredSearches"
      :per-page="6"
      sortable
      :sort-keys="sortKeys"
      @sortTable="sortTable"
    )
      template(slot-scope="props")
        tr
          td
            div.border-right.actions
              router-link(:to="{path: 'search_results', query: {id: props.entry.id}}") View Results
            div.actions
              a(href="javascript:void(0);" @click.prevent="redoSearch(props.entry.id)") Redo Search
          td {{ props.entry.count }}
          td {{ props.entry.date }}
          td
            div(v-for="key, value of props.entry.criteria")
              strong {{ value }}:
              |  {{ key }}
          td {{ props.entry.purposeCode }}
          td {{ props.entry.states }}
</template>

<script>
import PageHeader from '@/components/PageHeader'
import SearchBar from '@/components/SearchBar'
import Datatable from '@/components/Datatable'

import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'
import { parse, format, differenceInSeconds } from 'date-fns/esm'
import * as personService from '../lib/services/personSearch'

export default {
  name: 'MySearches',
  data() {
    return {
      data: [],
      sortDir: 'desc',
      sortKey: 'date',
      searchText: '',
      columns: [
        'Actions',
        'Results Returned',
        'Date/Time Initiated',
        'Search Criteria',
        'Purpose Code',
        'Locations',
      ],
      sortKeys: [null, 'count', 'date', null, 'purposeCode', null],
    }
  },
  computed: {
    searches() {
      return this.data.map(d => {
        let st = d.searchCriteria.search_states
        return {
          count: d.count,
          date: format(new Date(d.createdAt * 1000), 'MM/dd/yyyy hh:mm a'),
          criteria: this.searchCriteria(d.searchCriteria),
          purposeCode: d.searchCriteria.purpose_code,
          states: st ? st.join(', ') : 'All States',
          id: d.id,
        }
      })
    },
    sortedSearches() {
      let sorted = [...this.searches]
      if (this.sortKey === null) {
        return sorted
      }
      sorted = sorted.sort((a, b) => {
        if (this.sortKey === 'count') {
          return a.count - b.count
        }
        if (this.sortKey === 'date') {
          let [dtA, dtB] = [
            parse(a.date, 'MM/dd/yyyy hh:mm:ss', new Date()),
            parse(b.date, 'MM/dd/yyyy hh:mm:ss', new Date()),
          ]
          return differenceInSeconds(dtA, dtB)
        }
        if (this.sortKey === 'purposeCode') {
          if (a.purposeCode < b.purposeCode) return -1
          else return 1
        }
      })
      if (this.sortDir === 'asc') sorted.reverse()
      return sorted
    },
    filteredSearches() {
      let filtered = [...this.sortedSearches]
      const st = this.searchText.toLowerCase()
      if (!st) return filtered
      return filtered.filter(s => {
        if (s.count.toString().includes(st)) return true
        if (s.date.includes(st)) return true
        if (s.purposeCode.toLowerCase().includes(st)) return true
        if (s.states.toLowerCase().includes(st)) return true
        if (
          Object.values(s.criteria)
            .map(v => v && v.toLowerCase().includes(st))
            .some(v => v)
        )
          return true
        return false
      })
    },
  },
  methods: {
    searchCriteria(criteria) {
      let ret = {}
      if (criteria.last_name) {
        ret['Name'] = `${criteria.last_name}, ${
          criteria.first_name
        } ${criteria.middle_name || ''}`
      }
      if (criteria.birth_dt) {
        ret['Date of Birth'] = criteria.birth_dt
      }
      if (criteria.id_nbr) {
        ret['Unique ID'] = criteria.id_nbr
      }
      if (criteria.address1) {
        ret['Address'] = `${criteria.address1}. ${criteria.city}, ${
          criteria.state_cd
        } ${criteria.postal_code}`
      }
      return ret
    },
    sortTable({ sortDir, sortKey }) {
      this.sortDir = sortDir
      this.sortKey = sortKey
    },
    redoSearch(id) {
      let data = this.data.find(el => el.id === id)
      if (!data) return
      personService
        .search(data.searchCriteria)
        .then(resp => {
          this.$router.push({
            name: 'search_results',
            query: { id: resp.data.id },
          })
        })
        .catch(err => globalError(err))
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      let resp = await axios().get('/api/search/search_history')
      next(vm => (vm.data = resp.data))
    } catch (err) {
      globalError(err)
    }
  },
  mounted() {
    scrollTo(0, 0)
  },
  components: { PageHeader, SearchBar, Datatable },
}
</script>

<style lang="scss" scoped>
.panel-white {
  width: 1007px;
}

.unviewed-search {
  color: #4d4d4d;
  font-style: italic;
  font-family: Arial, Helvetica, sans-serif;
}

.border-right {
  border-right: 1px solid #e6e6e6;
}

.actions {
  padding: 0.8rem;
  display: inline;
  white-space: nowrap;
}

.search {
  width: 270px;
}
</style>
